import { z } from "zod";

import { CustomSaasType } from "@/constants/customSaas";

export const SearchSchema = z.object({
  traceableSaasId: z.string().optional(),
});

export const ParamsSchema = z.object({
  customSaasType: z.nativeEnum(CustomSaasType),
});
